__turbopack_context__.v({
  "bannerImage": "solutions-section-module-scss-module__s3Ez1a__bannerImage",
  "bannerSection": "solutions-section-module-scss-module__s3Ez1a__bannerSection",
  "cardDescription": "solutions-section-module-scss-module__s3Ez1a__cardDescription",
  "cardHeading": "solutions-section-module-scss-module__s3Ez1a__cardHeading",
  "container": "solutions-section-module-scss-module__s3Ez1a__container",
  "contentCard": "solutions-section-module-scss-module__s3Ez1a__contentCard",
  "contentWrapper": "solutions-section-module-scss-module__s3Ez1a__contentWrapper",
  "ctaIcon": "solutions-section-module-scss-module__s3Ez1a__ctaIcon",
  "ctaLink": "solutions-section-module-scss-module__s3Ez1a__ctaLink",
  "ctaText": "solutions-section-module-scss-module__s3Ez1a__ctaText",
  "selected": "solutions-section-module-scss-module__s3Ez1a__selected",
  "selectedTag": "solutions-section-module-scss-module__s3Ez1a__selectedTag",
  "skillTag": "solutions-section-module-scss-module__s3Ez1a__skillTag",
  "tagsContainer": "solutions-section-module-scss-module__s3Ez1a__tagsContainer",
  "title": "solutions-section-module-scss-module__s3Ez1a__title",
});
